var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('error-modal'),_c('logo-loading'),_c('nav-component'),_c('btn-scroll-top'),_c('afip-reenviar-facturas'),_c('articles-stock-minimo'),_c('b-container',{attrs:{"fluid":""}},[_c('payment-expire'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }